<template>
    <div id="wrapper">
        <div class="page-wrapper">

            <!-- Header && Menus -->
            <Header></Header>

            <!-- Child routes -->
            <div>
                <router-view/>
            </div>

        </div>
    </div>
</template>

<script>
import Header from './layouts/Header'

export default {
    name: 'Home',
    components: {
        Header
    },
    created () {
        this.redirectIfNotAuthenticated()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue